export const parseScheduleDateFilter = (date) => {
    switch (date) {
        case "TODAY":
            return "today";
        case "YESTERDAY":
            return "yesterday";
        case "LAST_7_DAYS":
            return "7 day";
        case "LAST_14_DAYS":
            return "14 day";
        case "LAST_30_DAYS":
            return "30 day";
        case "LAST_90_DAYS":
            return "90 day";
        case "LAST_180_DAYS":
            return "180 day";
        case "YTD":
            return "this year";
        case "THIS_WEEK":
            return "this week";
        case "THIS_MONTH":
            return "this month";
        case "THIS_QUARTER":
            return "this quarter";
        case "THIS_YEAR":
            return "this year";
        case "PREV_WEEK":
            return "last week";
        case "PREV_MONTH":
            return "last month";
        case "PREV_QUARTER":
            return "last quarter";
        case "PREV_YEAR":
            return "last year";
        default:
            return "today";
    }
};
export const frequencyToCron = (frequency) => {
    switch (frequency.date) {
        case "monthly": {
            const [monthHour, monthMinute] = frequency.time.split(":");
            return `${monthMinute} ${monthHour} ${frequency.day} * *`;
        }
        case "weekly": {
            const [weekHour, weekMinute] = frequency.time.split(":");
            return `${weekMinute} ${weekHour} * * ${frequency.day}`;
        }
        case "daily": {
            const [dayHour, dayMinute] = frequency.time.split(":");
            return `${dayMinute} ${dayHour} * * *`;
        }
        case "hourly": {
            const [startHour, startMinute] = frequency.startTime.split(":");
            const [endHour] = frequency.endTime.split(":");
            return `${startMinute} ${startHour}-${endHour}/${frequency.recurrence} * * *`;
        }
        case "minutes": {
            const [startHour] = frequency.startTime.split(":");
            const [endHour] = frequency.endTime.split(":");
            return `*/${frequency.recurrence} ${startHour}-${endHour} * * *`;
        }
        default:
            throw new Error("Invalid frequency type");
    }
};
//# sourceMappingURL=schedule.js.map